/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listPools} from '../api'

export const useMutationListPools = createReactQueryMutationHook('listPools', listPools)
